"use client";

import { getClientFunctions } from "@/lib/firebase-client";
import { httpsCallable } from "firebase/functions";

export type SendSupportRequestInput = {
  subject: string;
  message: string;
  ccUser?: boolean;
};

export type SendSupportRequestResult = {
  success: boolean;
};

/**
 * Send a support request
 */
export async function sendSupportRequest(
  input: SendSupportRequestInput,
): Promise<SendSupportRequestResult> {
  const functions = getClientFunctions();
  if (!functions) {
    throw new Error("Firebase functions are not available in this environment");
  }

  const callable = httpsCallable<SendSupportRequestInput, SendSupportRequestResult>(
    functions,
    "sendSupportRequest",
  );

  const response = await callable(input);
  return response.data;
}

